import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import './landing.css';

const HERO_IMAGE =
  'https://lh3.googleusercontent.com/aida-public/AB6AXuCQbnFZr0Uxlav5JPwThlq0-7IqdG-bdktOBXI3tPVzRDr6mP5PNAAxQKFXRmXE5Oz73WVvnRrJwawAkj1kvDkdgaiR7eZrAPlAzhw1FQUDl8PtPEEzGh45sKjB7NHs8nk7dy24EMF_szrQvlooYFP4xN508KIzgTD5Bz6vdU6CO_es_Iv7X7tVkYSdLP11SJL3-0Rt7YBZ0K-xl2JVRFrvwUBn4oLdzvNi-PLswmEsoymZQhugWgZGE7uKGIcXjRFUk4rhBcMP9wY';

const COURSE_IMAGES = [
  'https://lh3.googleusercontent.com/aida-public/AB6AXuBR4CmWgYHMSXzyvBqnq-f8_UglsSwy-3aCJgcdqLAvj4ApHXZeQ8NKfZPkrYc-ZxndJ_ZPcZw5s8VD5VsuBKioiRGkvfi3wy6DH2smJhR4_4sbTOOEOUA-RO-onD_W-bRiwp0wbzq0-SvOwT-9H32DkmCfS5QkiZLNjmVdA31BflnS7ZvWbtUA5b62u-QF9udXpApbESlpMlSxjlbBeaw6f9vE3one98d9XFD1QKYRmW12Z_sRt8UsNJnkfhGTl99zqRfm2C1Qwdg',
  'https://lh3.googleusercontent.com/aida-public/AB6AXuCMcrupxmT_StKLB6411zs93g-6jGRv184msGcro9Q9CN9oZ1s2ienxm0vUvBpUrQP4y0oLo9vqzXL_eAkdfl5Rsj9-1UkmvB2A4WoTLB6iacg9t7sAb9ER361SVy91wAjkENtdZ1NCA0M3zCaPUfbQxbc6pEEi29Jo1st8HaLrSRrIhRcgJtrN163jjqoWKeidowuuq79007cCyl5arTOIYEMM3OjZPjF5hljd_UtxZ6JxcDPmm9HVtK1EYNj4rFvRSJ1e2nrdXrs',
  'https://lh3.googleusercontent.com/aida-public/AB6AXuA4-m3ws1Hu7qBf78sED7l74QxT218nwFxjbNMI3cbB20m3YgU4uFX7a1_HpiFYFC8qgBgEltnU0uC41JttCcLVWnunfrhJnMm9SmJpsTuntbYhddhGxBgMG5kiBBzRvhYCSeCRTRjuKCJj99fBX1sfbkAixJuS20RrTjkkOT5vzPKxRNhlsttyz2mAK8ohjU57lfw4n2nwCI2lgQVcYQxR9uKd296MOXmgZGpCwAxaU6BM9-SgVbu1VR_OMT6mVgwW1aJltD2rVok'
];

const CLIP_IMAGE =
  'https://lh3.googleusercontent.com/aida-public/AB6AXuAPF2k3RpgJ_RFYG_zfd9BLZcqrDnA6yneAlkdhgdNw0FjkH8DA2Ol-7s4n0LuLYcw9WAN1EmaxEkL4v-a5p2dm_lsMhDJ7lsihl0gJ8wUfz6WCOnnb29C0NIZpAMpT_CFdJAK_LDUvS9O-qnAqKxzIsCLmhcb8_INL50cwZt8QkewQnF6XbvyJZ0VotRkzIWHT2NLM-Yy4kFoNRGnWDjKnEFUmYTH6MBXJC0p7QrgslWCl8_gdbAscTWu8w_nuxkD4_NEK6CZAoxM';

const COURSES = [
  {
    title: 'Blade Mastery',
    description:
      'Master advanced sword spacing, axe crit-combos, and movement-based mitigation techniques.'
  },
  {
    title: 'Projectile Precision',
    description:
      'Frame-perfect bow shots, rod-tricks, and crossbow suppression for mid-range dominance.'
  },
  {
    title: 'Endgame Tactics',
    description:
      'The pinnacle of technical PVP. Crystal placement speed, anchor charging, and double-hit timings.'
  }
];

const RANKINGS = [
  { rank: '#02', name: 'VOIDWALKER', winRate: '94.1%' },
  { rank: '#03', name: 'PvP_Pro', winRate: '91.8%' },
  { rank: '#04', name: 'CRIT_MASTER', winRate: '89.5%' }
];

function GetStartedButton({
  children,
  className = ''
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <Link to="/login" className={className}>
      {children}
    </Link>
  );
}

export default function Landing() {
  return (
    <div className="landing-page lp-bg-background lp-text-on-surface font-body-md selection:bg-[#c0392b] selection:text-white">
      <nav className="fixed top-0 w-full z-50 lp-bg-surface border-b-2 lp-border-primary">
        <div className="flex justify-between items-center px-4 md:px-12 h-16 w-full max-w-[1280px] mx-auto">
          <div className="font-display-xl text-headline-md lp-primary tracking-tighter">
            PVP ACADEMY
          </div>
          <GetStartedButton className="lp-primary-container lp-on-primary-container font-label-caps text-label-caps px-6 py-2 border-2 border-black active:translate-y-1 transition-transform uppercase inline-block">
            JOIN NOW
          </GetStartedButton>
        </div>
      </nav>

      <main className="pt-16">
        <section className="relative min-h-[921px] flex flex-col items-center justify-center text-center px-4 md:px-12 overflow-hidden">
          <div className="absolute inset-0 z-0 opacity-40">
            <div className="absolute inset-0 bg-gradient-to-t from-[#131313] via-transparent to-transparent" />
            <img className="w-full h-full object-cover" alt="" src={HERO_IMAGE} />
          </div>
          <div className="relative z-10 max-w-4xl noise-bg p-8">
            <h1 className="font-display-xl text-display-xl md:text-[120px] md:leading-[110px] uppercase mb-6 drop-shadow-[4px_4px_0px_#c0392b]">
              DOMINATE THE ARENA.
            </h1>
            <p className="font-body-lg text-body-lg mb-10 max-w-2xl mx-auto lp-text-on-surface-variant uppercase tracking-widest">
              Grind and climb, one match at a time.
            </p>
            <div className="flex flex-col md:flex-row gap-6 justify-center">
              <GetStartedButton className="lp-primary-container lp-on-primary-container font-headline-md text-headline-md px-12 py-5 border-4 border-black hard-shadow-primary hover:translate-x-[-2px] hover:translate-y-[-2px] active:translate-x-0 active:translate-y-0 transition-all uppercase glitch-hover inline-block">
                START TRAINING
              </GetStartedButton>
            </div>
          </div>
        </section>

        <section className="py-24 px-4 md:px-12 lp-bg-surface-container-low border-y-2 lp-border-primary">
          <div className="max-w-[1280px] mx-auto">
            <div className="flex items-center gap-4 mb-16">
              <div className="h-1 w-24 lp-primary-container" />
              <h2 className="font-display-xl text-headline-lg uppercase">MASTER THE ART OF WAR</h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {COURSES.map((course, i) => (
                <div
                  key={course.title}
                  className="lp-course-card lp-bg-surface border-2 lp-border-primary p-0 flex flex-col group transition-colors"
                >
                  <div className="h-48 overflow-hidden bg-[#c0392b]/20 border-b-2 lp-border-primary">
                    <img
                      className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500"
                      alt=""
                      src={COURSE_IMAGES[i]}
                    />
                  </div>
                  <div className="p-6 flex-grow">
                    <h3 className="font-headline-md text-headline-md mb-4 lp-primary uppercase">
                      {course.title}
                    </h3>
                    <p className="font-body-md text-body-md lp-text-on-surface-variant mb-6">
                      {course.description}
                    </p>
                    <span className="font-label-caps text-label-caps uppercase lp-primary border-b-2 border-transparent hover:border-[#ffb4a9] transition-all flex items-center gap-2 group/link cursor-default">
                      View Syllabus
                      <span className="material-symbols-outlined text-[16px] group-hover/link:translate-x-1 transition-transform">
                        arrow_forward
                      </span>
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-24 px-4 md:px-12 lp-bg-surface">
          <div className="max-w-[1280px] mx-auto">
            <div className="mb-12">
              <span className="font-label-caps text-label-caps lp-primary uppercase tracking-tighter">
                ELITE RANKINGS
              </span>
              <h2 className="font-display-xl text-headline-lg uppercase mt-2">THE HALL OF FAME</h2>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              <div className="lg:col-span-1 lp-primary-container border-4 border-black hard-shadow relative overflow-hidden group">
                <div className="absolute top-0 right-0 p-4">
                  <span className="bg-black text-white font-label-caps text-label-caps px-3 py-1 border-2 border-white uppercase tracking-widest">
                    CHAMPION
                  </span>
                </div>
                <div className="p-8 pt-16">
                  <div className="w-24 h-24 bg-black border-4 border-white mb-6 flex items-center justify-center">
                    <span className="material-symbols-outlined text-white text-6xl">person</span>
                  </div>
                  <h3 className="font-display-xl text-headline-lg text-white uppercase mb-2">
                    NETHERGOD
                  </h3>
                  <div className="flex gap-6 border-t-2 border-black/20 pt-6">
                    <div>
                      <p className="font-label-caps text-label-caps text-black/60 uppercase">
                        ELO RATING
                      </p>
                      <p className="font-display-xl text-headline-md text-white">2850</p>
                    </div>
                    <div>
                      <p className="font-label-caps text-label-caps text-black/60 uppercase">KDR</p>
                      <p className="font-display-xl text-headline-md text-white">4.2</p>
                    </div>
                  </div>
                  <div className="mt-8">
                    <div className="flex justify-between font-label-caps text-label-caps text-white mb-2">
                      <span>WIN RATE</span>
                      <span>98.4%</span>
                    </div>
                    <div className="h-2 bg-black/20 border border-black/10">
                      <div className="h-full bg-white" style={{ width: '98.4%' }} />
                    </div>
                  </div>
                </div>
              </div>

              <div className="lg:col-span-2 flex flex-col gap-4">
                {RANKINGS.map((entry) => (
                  <div
                    key={entry.rank}
                    className="lp-ranking-row lp-bg-surface-container border-2 border-[#ffb4a9]/30 p-4 flex items-center justify-between transition-colors group"
                  >
                    <div className="flex items-center gap-6">
                      <span className="font-display-xl text-headline-md lp-primary w-12">
                        {entry.rank}
                      </span>
                      <div className="w-12 h-12 lp-bg-surface-container-highest border-2 border-black flex items-center justify-center">
                        <span className="material-symbols-outlined lp-text-on-surface-variant">
                          person
                        </span>
                      </div>
                      <div>
                        <h4 className="font-headline-md lp-text-on-surface uppercase">
                          {entry.name}
                        </h4>
                        <p className="font-label-caps text-label-caps lp-text-on-surface-variant">
                          WIN RATE: {entry.winRate}
                        </p>
                      </div>
                    </div>
                    <button
                      type="button"
                      className="lp-view-profile-btn font-label-caps text-label-caps lp-primary border-2 lp-border-primary px-4 py-2 transition-all uppercase"
                    >
                      View Profile
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="py-24 px-4 md:px-12 lp-bg-surface-container-highest border-t-2 lp-border-primary overflow-hidden relative">
          <div className="absolute top-0 right-0 w-1/2 h-full opacity-10 pointer-events-none">
            <span className="font-display-xl text-[20vw] leading-none select-none lp-text-on-surface">
              RISE
            </span>
          </div>
          <div className="max-w-[1280px] mx-auto relative z-10 grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="font-display-xl text-headline-lg uppercase mb-8">RISE TO FAME</h2>
              <p className="font-body-lg text-body-lg lp-text-on-surface-variant mb-8 uppercase tracking-wide">
                Your skills deserve a stage. Record your most insane clutches, perfect combos, and
                flawless victories.
              </p>
              <div className="space-y-6 mb-10 font-body-md text-body-md">
                <div className="flex gap-4 items-start">
                  <span className="material-symbols-outlined lp-primary">videocam</span>
                  <p>Submit raw footage in high bitrate (1080p60+).</p>
                </div>
                <div className="flex gap-4 items-start">
                  <span className="material-symbols-outlined lp-primary">verified</span>
                  <p>Our veteran coaches review and curate the top 1%.</p>
                </div>
                <div className="flex gap-4 items-start">
                  <span className="material-symbols-outlined lp-primary">trending_up</span>
                  <p>Get featured on the home page and gain massive exposure.</p>
                </div>
              </div>
              <button
                type="button"
                className="lp-primary-container lp-on-primary-container font-headline-md text-headline-md px-10 py-4 border-2 border-black hard-shadow-primary active:scale-95 transition-all uppercase"
              >
                SUBMIT CLIP
              </button>
            </div>
            <div className="relative group">
              <div className="absolute -inset-4 lp-primary-container opacity-20 -rotate-3 transition-transform group-hover:rotate-0" />
              <div className="relative aspect-video border-4 border-black bg-black overflow-hidden hard-shadow">
                <img
                  className="w-full h-full object-cover opacity-80 group-hover:opacity-100 transition-opacity"
                  alt=""
                  src={CLIP_IMAGE}
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <button
                    type="button"
                    className="w-20 h-20 lp-primary-container lp-on-primary-container flex items-center justify-center border-4 border-black shadow-xl group-hover:scale-110 transition-transform"
                  >
                    <span className="material-symbols-outlined text-4xl">play_arrow</span>
                  </button>
                </div>
                <div className="absolute bottom-4 left-4 bg-black/80 px-4 py-1 border-l-4 lp-border-primary-container">
                  <span className="font-label-caps text-label-caps uppercase text-white">
                    Clip of the week: Player &apos;VoidWalker&apos;
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-32 px-4 md:px-12 lp-bg-surface text-center border-t-2 lp-border-primary relative overflow-hidden">
          <div className="absolute inset-0 opacity-5 pointer-events-none noise-bg" />
          <div className="max-w-4xl mx-auto relative z-10">
            <h2 className="font-display-xl text-display-xl uppercase mb-4 tracking-tighter">
              READY TO CLIMB?
            </h2>
            <p className="font-body-lg text-body-lg lp-text-on-surface-variant mb-12 uppercase tracking-[0.2em]">
              Stop losing. Start dominating. Join the elite 1% of PVP combatants.
            </p>
            <div className="p-2 border-4 lp-border-primary inline-block">
              <GetStartedButton className="lp-primary-container lp-on-primary-container font-display-xl text-headline-lg px-16 py-8 border-4 border-black hard-shadow hover:translate-x-[-4px] hover:translate-y-[-4px] active:translate-x-0 active:translate-y-0 transition-all uppercase glitch-hover inline-block">
                JOIN THE ACADEMY
              </GetStartedButton>
            </div>
          </div>
        </section>
      </main>

      <footer className="w-full border-t-2 lp-border-primary lp-bg-surface-container-lowest">
        <div className="flex flex-col md:flex-row justify-between items-center py-12 px-4 md:px-12 w-full max-w-[1280px] mx-auto">
          <div className="font-display-xl text-headline-md lp-text-on-surface mb-8 md:mb-0">
            PVP ACADEMY
          </div>
          <div className="flex flex-col md:flex-row items-center gap-8 mb-8 md:mb-0">
            <a
              href="#"
              className="font-label-caps text-label-caps uppercase lp-text-on-surface-variant hover:lp-primary transition-colors active:scale-95"
            >
              DISCORD
            </a>
            <a
              href="#"
              className="font-label-caps text-label-caps uppercase lp-text-on-surface-variant hover:lp-primary transition-colors active:scale-95"
            >
              YOUTUBE
            </a>
            <a
              href="#"
              className="font-label-caps text-label-caps uppercase lp-text-on-surface-variant hover:lp-primary transition-colors active:scale-95"
            >
              TERMS
            </a>
            <a
              href="#"
              className="font-label-caps text-label-caps uppercase lp-text-on-surface-variant hover:lp-primary transition-colors active:scale-95"
            >
              PRIVACY
            </a>
          </div>
          <div className="font-label-caps text-label-caps uppercase lp-text-on-surface-variant text-center md:text-right">
            © 2024 PVP ACADEMY. DOMINANCE IS EARNED.
          </div>
        </div>
      </footer>
    </div>
  );
}
